"use client";
import React, { useState, useRef, useEffect } from "react";
import HourOptions from "./HourOption";
import MinuteOptions from "./MinuteOption";
import { TiArrowSortedUp, TiArrowSortedDown } from "react-icons/ti";
import { MdAccessTime } from "react-icons/md";

const TimePicker = ({
  inputClick,
  setInputClick,
  selectedHour,
  setSelectedHour,
  selectedMinute,
  setSelectedMinute,
  isAM,
  setIsAM,
  timeError,
  id,
  type,
}) => {
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [isHourOptionVisible, setIsHourOptionVisible] = useState(null);
  const dropdownRef = useRef(null); // Ref for dropdown container
  const inputRef = useRef(null); // Ref for input field

  // useEffect(() => {
  //   // Function to handle clicks outside the dropdown
  //   function handleClickOutside(event) {
  //     if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
  //       setIsDropdownVisible(false);
  //     }
  //   }
  //   // Add event listener when the component mounts
  //   document.addEventListener("mousedown", handleClickOutside);
  //   // Remove event listener when the component unmounts
  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, [dropdownRef]);

  useEffect(() => {
    // Function to handle clicks outside the dropdown
    function handleClickOutside(event) {
      // Check if click is outside both the input and dropdown
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        inputRef.current &&
        !inputRef.current.contains(event.target)
      ) {
        setIsDropdownVisible(false);
        setIsHourOptionVisible(null); // Close dropdown if clicked outside
      }
    }
    // Add event listener when the component mounts
    document.addEventListener("mousedown", handleClickOutside);
    // Remove event listener when the component unmounts
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // const handleInputClick = () => {
  //   setIsDropdownVisible((prevState) => !prevState); // Toggle the dropdown visibility
  //   setInputClick(true);
  //   if (type === "return") {
  //     localStorage.setItem("returntimeinputClick", JSON.stringify(true));
  //     localStorage.setItem("returnselectedHour", JSON.stringify(selectedHour));
  //     localStorage.setItem(
  //       "returnselectedMinute",
  //       JSON.stringify(selectedMinute)
  //     );
  //     localStorage.setItem("returnisAM", JSON.stringify(isAM));
  //   } else if (type === "original") {
  //     localStorage.setItem("inputClick", JSON.stringify(true));
  //     localStorage.setItem("selectedHour", JSON.stringify(selectedHour)); // Set the updated value in localStorage
  //     localStorage.setItem("selectedMinute", JSON.stringify(selectedMinute)); // Set the updated value in localStorage
  //     localStorage.setItem("isAM", JSON.stringify(isAM)); // Set the updated value in localStorage
  //   }
  // };

  const handleInputClick = (e) => {
    e.stopPropagation();
    if (isDropdownVisible) {
      setIsDropdownVisible(false); // Close the dropdown
    } else {
      setIsDropdownVisible(true); // Open the dropdown
    }
    // Rest of the local storage logic
    setInputClick(true);
    if (type === "return") {
      localStorage.setItem("returntimeinputClick", JSON.stringify(true));
      localStorage.setItem("returnselectedHour", JSON.stringify(selectedHour));
      localStorage.setItem(
        "returnselectedMinute",
        JSON.stringify(selectedMinute)
      );
      localStorage.setItem("returnisAM", JSON.stringify(isAM));
    } else if (type === "original") {
      localStorage.setItem("inputClick", JSON.stringify(true));
      localStorage.setItem("selectedHour", JSON.stringify(selectedHour));
      localStorage.setItem("selectedMinute", JSON.stringify(selectedMinute));
      localStorage.setItem("isAM", JSON.stringify(isAM));
    }
  };

  const hourDropdown = () => {
    setIsHourOptionVisible(true);
  };

  const minuteDropdown = () => {
    setIsHourOptionVisible(false);
  };

  const hideDropdown = () => {
    setIsHourOptionVisible(null);
  };

  const handleHourIncrement = () => {
    setSelectedHour((prevHour) => {
      const incrementedHour = (prevHour % 12) + 1; // Increment hour and handle wrapping
      if (type === "return") {
        localStorage.setItem(
          "returnselectedHour",
          JSON.stringify(incrementedHour)
        );
      } else {
        localStorage.setItem("selectedHour", JSON.stringify(incrementedHour)); // Set the updated value in localStorage
      }
      return incrementedHour === 0 ? 12 : incrementedHour; // If the incremented hour is 0, set it to 12
    });
  };

  const handleHourDecrement = () => {
    setSelectedHour((prevHour) => {
      const decrementedHour = (prevHour - 1 + 12) % 12 || 12; // Decrement hour and handle wrapping
      if (type === "return") {
        localStorage.setItem(
          "returnselectedHour",
          JSON.stringify(decrementedHour)
        );
      } else {
        localStorage.setItem("selectedHour", JSON.stringify(decrementedHour)); // Set the updated value in localStorage
      }
      return decrementedHour;
    });
  };

  const handleMinuteIncrement = () => {
    const minutes = [
      "00",
      "05",
      "10",
      "15",
      "20",
      "25",
      "30",
      "35",
      "40",
      "45",
      "50",
      "55",
    ];
    const currentIndex = minutes.indexOf(selectedMinute);
    const nextIndex = (currentIndex + 1) % minutes.length;
    setSelectedMinute(minutes[nextIndex]);
    if (type === "return") {
      localStorage.setItem(
        "returnselectedMinute",
        JSON.stringify(minutes[nextIndex])
      );
    } else {
      localStorage.setItem(
        "selectedMinute",
        JSON.stringify(minutes[nextIndex])
      );
    }
  };

  const handleMinuteDecrement = () => {
    const minutes = [
      "00",
      "05",
      "10",
      "15",
      "20",
      "25",
      "30",
      "35",
      "40",
      "45",
      "50",
      "55",
    ];
    const currentIndex = minutes.indexOf(selectedMinute);
    const prevIndex = (currentIndex - 1 + minutes.length) % minutes.length;
    setSelectedMinute(minutes[prevIndex]);
    if (type === "return") {
      localStorage.setItem(
        "returnselectedMinute",
        JSON.stringify(minutes[prevIndex])
      );
    } else {
      localStorage.setItem(
        "selectedMinute",
        JSON.stringify(minutes[prevIndex])
      );
    }
  };

  // const toggleAMPM = (midday) => {
  //   // setIsAM((prevIsAM) => !prevIsAM); // Toggle between AM and PM
  //   // const updatedIsAM = !isAM; // Toggle between AM and PM
  //   setIsAM(midday); // Update state
  //   if (type === "return") {
  //     localStorage.setItem("returnisAM", JSON.stringify(midday));
  //   } else {
  //     localStorage.setItem("isAM", JSON.stringify(midday));
  //   }
  // };

  const toggleAMPM = () => {
    // setIsAM((prevIsAM) => !prevIsAM); // Toggle between AM and PM
    const updatedIsAM = !isAM; // Toggle between AM and PM
    setIsAM(updatedIsAM); // Update state
    if (type === "return") {
      localStorage.setItem("returnisAM", JSON.stringify(updatedIsAM));
    } else {
      localStorage.setItem("isAM", JSON.stringify(updatedIsAM));
    }
  };

  const handleSubmit = () => {
    setIsDropdownVisible(false);
    const timeString = `${selectedHour
      .toString()
      .padStart(2, "0")}:${selectedMinute.toString().padStart(2, "0")} ${isAM}`;
    // document.getElementById("timeInput").value = timeString; // Display selected time in input field
    // Set the value using ref
    if (inputRef.current) {
      inputRef.current.value = timeString; // Use the ref to set the value
    }
  };
  return (
    <div className="">
      <div className="">
        <div className="relative rounded-sm">
          <input
            ref={inputRef}
            className={`block w-full h-[56px] rounded-[4px] px-3 py-1.5 text-black placeholder:text-gray-400 text-[16px] sm:text-sm sm:leading-6
    ${
      timeError
        ? "!border-[#FF0000] focus:!border-[#FF0000] hover:!border-[#FF0000]"
        : "!border-[#c4c4c4] focus:!border-black hover:!border-black"
    } border`}
            type="text"
            placeholder="HH:MM AM"
            id={id}
            onClick={handleInputClick}
            value={
              inputClick
                ? `${selectedHour?.toString().padStart(2, "0")}:${selectedMinute
                    ?.toString()
                    .padStart(2, "0")} ${isAM ? "AM" : "PM"}`
                : ""
            }
            readOnly
          />

          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
            <MdAccessTime
              className="h-5 w-5 text-gray-500"
              aria-hidden="true"
            />
          </div>
          {isDropdownVisible === true ? (
            <>
              <div
                style={{
                  boxShadow:
                    " 0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12)",
                }}
                ref={dropdownRef}
                className="py-2 bg-white border border-gray-400 rounded absolute z-50"
              >
                {isHourOptionVisible === true && (
                  <HourOptions
                    setSelectedHour={setSelectedHour}
                    hideDropdown={hideDropdown}
                  />
                )}
                {isHourOptionVisible === false && (
                  <MinuteOptions
                    setSelectedMinute={setSelectedMinute}
                    hideDropdown={hideDropdown}
                  />
                )}
                {isHourOptionVisible === null && (
                  <div style={{ width: "237px" }}>
                    <div className="flex justify-center">
                      <div className="flex flex-col justify-between text-center">
                        {/* Hour */}
                        <button
                          className="text-4xl px-2 text-[#2B3252]"
                          onClick={handleHourIncrement}
                        >
                          <TiArrowSortedUp />
                        </button>
                        <div
                          className="bg-transparent text-4xl appearance-none outline-none p-0 text-[#2B3252] cursor-pointer"
                          // onClick={hourDropdown}
                        >
                          {/* Display hour */}
                          {selectedHour?.toString().padStart(2, "0")}{" "}
                        </div>
                        <button
                          className="text-4xl px-2 text-[#2B3252]"
                          onClick={handleHourDecrement}
                        >
                          <TiArrowSortedDown />
                        </button>
                        {/* Hour */}
                      </div>
                      <span className="text-2xl mr-1 ml-0.5 mt-8 text-[#2B3252]">
                        :
                      </span>
                      <div className="flex flex-col justify-between text-center">
                        {/* Minute */}
                        <button
                          className="text-4xl px-2 text-[#2B3252]"
                          onClick={handleMinuteIncrement}
                        >
                          <TiArrowSortedUp />
                        </button>
                        <div
                          className="bg-transparent text-4xl appearance-none outline-none text-[#2B3252] cursor-pointer"
                          // onClick={minuteDropdown}
                        >
                          {selectedMinute.toString().padStart(2, "0")}{" "}
                          {/* Display minute */}
                        </div>
                        <button
                          className="text-4xl px-2 text-[#2B3252]"
                          onClick={handleMinuteDecrement}
                        >
                          <TiArrowSortedDown />
                        </button>
                        {/* Minute */}
                      </div>
                      <span className="text-2xl mr-1 ml-0.5 mt-[28px] py-1 text-[#2B3252]">
                        :
                      </span>
                      <div className="flex flex-col justify-between">
                        <button
                          className="text-4xl px-2.5 text-[#2B3252]"
                          onClick={toggleAMPM}
                        >
                          <TiArrowSortedUp />
                        </button>
                        <button
                          className="bg-transparent text-2xl appearance-none outline-none text-[#2B3252]"
                          onClick={toggleAMPM}
                          style={{ fontSize: "26px" }}
                        >
                          {isAM ? "AM" : "PM"}
                        </button>
                        <button
                          className="text-4xl px-2.5 text-[#2B3252]"
                          onClick={toggleAMPM}
                        >
                          <TiArrowSortedDown />
                        </button>
                      </div>
                      <div className="px-2 pt-2">
                        <button
                          className="w-full mt-7 px-2 py-0.5 text-white bg-[#D5AF34] rounded"
                          onClick={handleSubmit}
                        >
                          OK
                        </button>
                      </div>
                    </div>
                    {/* <div className="px-2">
                    <button
                      className="w-full mt-2 py-0.5 text-white bg-[#D5AF34] rounded"
                      onClick={handleSubmit}
                    >
                      Set Time
                    </button>
                  </div> */}
                  </div>
                )}
              </div>
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};
export default TimePicker;
